<template>
  <div>deposit</div>
</template>
<script>
export default {
  created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        console.log("prev", previousParams);
        console.log("to", toParams);
        // react to route changes...
      },
    );
  },
};
</script>
